export { default } from './PaymentIcon';
